webpackJsonp([96961042003272],{

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageTemplate = function PageTemplate(_ref) {
	  var data = _ref.data;
	
	  var node = data.nodePage;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "h1",
	      null,
	      node.title
	    ),
	    _react2.default.createElement("div", {
	      dangerouslySetInnerHTML: { __html: node.body.processed }
	    })
	  );
	};
	
	exports.default = PageTemplate;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-js-56949ddf65ffe3b9eec9.js